import React, { useState } from 'react';
import type { KeyboardEvent } from 'react';
import { Button } from '../common/Button';

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export const ChatInput: React.FC<ChatInputProps> = ({ onSend, disabled, isLoading }) => {
  const [input, setInput] = useState('');

  const handleSend = () => {
    if (input.trim() && !disabled && !isLoading) {
      onSend(input);
      setInput('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="border-t border-gray-700 p-3 md:p-4 bg-dark">
      <div className="flex gap-2">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type your message..."
          disabled={disabled || isLoading}
          rows={1}
          className="flex-1 bg-dark-lighter text-white border border-gray-700 rounded-lg px-3 py-2.5 md:px-4 md:py-3 focus:outline-none focus:ring-2 focus:ring-primary resize-none scrollbar-thin touch-manipulation"
          style={{ maxHeight: '120px', minHeight: '44px', fontSize: '16px' }}
        />
        <Button
          onClick={handleSend}
          disabled={!input.trim() || disabled}
          isLoading={isLoading}
          size="md"
          variant="primary"
          className="touch-manipulation shrink-0"
          style={{ minWidth: '70px', minHeight: '44px' }}
        >
          <span className="hidden sm:inline">Send</span>
          <span className="sm:hidden">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
          </span>
        </Button>
      </div>
      <p className="text-xs text-gray-500 mt-2 hidden md:block">
        Press Enter to send, Shift+Enter for new line
      </p>
    </div>
  );
};
